import { Box, Divider, Stack } from '@/src/packages/components';
import { ProductTitle } from '@/src/packages/components/pages/Product/ProductTitle';
import { ProductPrice } from '@/src/packages/components/pages/Product/ProductPrice';
import { ProductDescription } from '@/src/packages/components/pages/Product/ProductControls/ProductDescription';
import { ProductOptions } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions';
import { ProductAddToCartButton } from '@/src/packages/components/pages/Product/ProductControls/ProductAddToCartButton';
import { Flex } from '@/src/packages/components/ui/Flex';
import { IReview } from '@/src/interfaces/generated/contentful';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { IFetchProductPriceListByCountry } from '@bitmap/contracts';
import { useProductForm } from '@/src/packages/components/contexts/product-form.context';

export const ProductMeta = ({
  title,
  reviews,
  priceList,
}: {
  title: string;
  reviews: IReview[];
  priceList: IFetchProductPriceListByCountry;
}) => {
  return (
    <Flex className="flex-col gap-4">
      <Flex className="flex-col space-y-1">
        <ProductTitle title={title} />
        <ProductPrice priceList={priceList} />
      </Flex>
    </Flex>
  );
};

export const ProductControls = () => {
  const {
    productVariant: {
      title,
      description,
      product: { priceList },
    },
    reviews,
  } = useProductContext();

  const { selectedSku } = useProductForm();

  return (
    <Stack spaceY={4}>
      <ProductMeta title={title} priceList={priceList} reviews={reviews} />
      <ProductDescription description={description} />
      <Divider borderColor="muted" />
      <ProductOptions />
      <ProductAddToCartButton selectedSku={selectedSku} priceList={priceList} />
    </Stack>
  );
};
